<template>

    <!-- SCHEDULE DETAILS -->
    <div v-if="scheduleDays" class="c-provider-card__schedule">
        <p class="section-title"><b>AVAILABLE APPOINTMENTS</b></p>
        <p>Select a time to schedule online</p>
        
        <div class="schedule-calendar__container js-schedule-carousel">
            <ScheduleDay v-for="( item, index ) in scheduleDays" :key="index" 
                :scheduleDay="item" 
                :providerId="providerId"
                :scheduleBaseUrl="scheduleBaseUrl"
                :locationId="locationId"/>
        </div>

        <div class="schedule-calendar__container footer">
            <a v-if="scheduleDays" :href="scheduleFullUrl" class="btn-primary btn-view-all">                
                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Small Icons_Desktop">
                        <path id="Vector" d="M13.9344 3.1498H13.2344V1.7998H11.8344V3.1498H6.23438V1.7998H4.83438V3.1498H4.13438C3.35738 3.1498 2.74137 3.7573 2.74137 4.4998L2.73438 13.9498C2.73438 14.3078 2.88187 14.6512 3.14443 14.9044C3.40698 15.1576 3.76307 15.2998 4.13438 15.2998H13.9344C14.7044 15.2998 15.3344 14.6923 15.3344 13.9498V4.4998C15.3344 3.7573 14.7044 3.1498 13.9344 3.1498ZM13.9344 13.9498H4.13438V7.1998H13.9344V13.9498ZM13.9344 5.8498H4.13438V4.4998H13.9344V5.8498ZM6.93438 9.89981H5.53438V8.5498H6.93438V9.89981ZM9.73438 9.89981H8.33438V8.5498H9.73438V9.89981ZM12.5344 9.89981H11.1344V8.5498H12.5344V9.89981ZM6.93438 12.5998H5.53438V11.2498H6.93438V12.5998ZM9.73438 12.5998H8.33438V11.2498H9.73438V12.5998ZM12.5344 12.5998H11.1344V11.2498H12.5344V12.5998Z" fill="white"/>
                    </g>
                </svg>
                View Full Schedule
            </a>
            <p class="hide-desktop">
                <b>TO SCHEDULE BY PHONE:</b><br/>
                <a :href="`tel:${ contactPhone }`" class="link">
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.92328 2.34681C3.98078 3.25531 4.14179 4.14081 4.38329 4.99181L3.15279 6.2223C2.73879 4.9918 2.46279 3.69231 2.37078 2.34681H3.91179H3.92328ZM13.9973 14.6288C14.8713 14.8703 15.7568 15.0313 16.6538 15.0888V16.6068C15.3083 16.5148 14.0088 16.2503 12.7668 15.8363L13.9973 14.6173V14.6288ZM4.90078 0.299805H1.32429C0.760789 0.299805 0.300781 0.759804 0.300781 1.3233C0.300781 10.9258 8.07478 18.6998 17.6773 18.6998C18.2408 18.6998 18.7008 18.2398 18.7008 17.6763V14.1113C18.7008 13.5478 18.2408 13.0878 17.6773 13.0878C16.4123 13.0878 15.1703 12.8808 14.0318 12.5013C13.9283 12.4668 13.8248 12.4438 13.7098 12.4553C13.4453 12.4553 13.1923 12.5588 12.9853 12.7543L10.7313 15.0083C7.83328 13.5248 5.47579 11.1673 3.99229 8.2693L6.24629 6.0153C6.53379 5.7278 6.61429 5.3253 6.49929 4.9688C6.10829 3.7958 5.91279 2.5538 5.91279 1.3233C5.91279 0.759804 5.45279 0.299805 4.88929 0.299805H4.90078Z" fill="#333333"/>
                    </svg>
                    {{ contactPhone }}
                </a>
            </p>
        </div>
    </div>
</template>

<style>
    @import '//cdn.jsdelivr.net/gh/kenwheeler/slick@1.8.1/slick/slick.css';
    @import '//cdn.jsdelivr.net/gh/kenwheeler/slick@1.8.1/slick/slick-theme.css';
</style>

<script>
import ScheduleDay from './ScheduleDay.vue';
import $ from 'jquery';
import 'slick-carousel';
import { mapGetters } from "vuex";

export default {
    name: "ScheduleTable",
    data: () => {
        return {
        };
    },
    props: {
        scheduleDays: Array,
        scheduleBaseUrl: String,
        locationId: String,
        providerId: String,
        phone: String,
        locations: Array,
    },
    computed: {
        ...mapGetters(["view"]),
        contactPhone: function(){
            return this.phone ?? '877-465-1856';
        },
        scheduleFullUrl: function(){
            return this.scheduleBaseUrl && this.scheduleBaseUrl.indexOf('locationID' == -1) ? `${this.scheduleBaseUrl}&locationID=${this.locationId}` : this.scheduleBaseUrl;
        }
    },
    methods: {
        initCarousel () {
            const breakpointDesktop = 1280;
            const breakpointTablet = 768;
            if(this.view == 'list' && $('.js-schedule-carousel').length > 3) {
                $('.js-schedule-carousel').not('.slick-initialized').slick({
                    arrows: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    responsive: [
                    {
                        breakpoint: breakpointDesktop,
                        settings: {
                            arrows: true,
                            // centerMode: true,
                            centerPadding: '40px',
                            slidesToShow: 3
                        }
                        },
                        {
                        breakpoint: breakpointTablet,
                        settings: {
                            arrows: false,
                            centerMode: false,
                            centerPadding: '40px',
                            slidesToShow: 1
                        }
                    }
                ]
                });
            }
        }
    },
    mounted() {
        this.initCarousel();
    },
    updated() {
        this.initCarousel();
    },
    components: {
        ScheduleDay
    }
};
</script>  